import api from './base/BaseApi';
import { handleApiError } from './base/handleApiError';
import { TGetAccountResponse, TRsAccountTaxInformation } from './types/Account';

export const getAccounts = async () =>
  api
    .get<TGetAccountResponse[]>('/api/v1/accounts')
    .then((response) => response)
    .catch(handleApiError);

export const getTaxInformation = async (accountId: string) =>
  api
    .get<TRsAccountTaxInformation>(`api/v1/accounts/${accountId}/tax-information`)
    .catch(handleApiError);
